var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.7083C9.5 12.2251 9.89175 11.8333 10.375 11.8333C13.4823 11.8333 16.5093 10.7326 19.475 8.50834C19.7861 8.27501 20.2139 8.27501 20.525 8.50834C23.4907 10.7326 26.5177 11.8333 29.625 11.8333C30.1082 11.8333 30.5 12.2251 30.5 12.7083V18.8333C30.5 24.6681 27.0495 28.955 20.3207 31.6058C20.1146 31.687 19.8854 31.687 19.6793 31.6058C12.9505 28.955 9.5 24.6681 9.5 18.8333V12.7083Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.e052b704e24d48cd966650bd6752d3ea.svg";
export { ForwardRef as ReactComponent };